(() => {
  const initSection = (section) => {
    if (!section?.classList.contains('section-product-slider')) return;
    const slider = section.querySelector('.swiper--products');
    if (!slider || typeof Swiper === 'undefined') return;

    if (slider.swiper) slider.swiper.destroy(true, true);

    const mobile = Number(slider.dataset.columnsMobile || 2);
    const tablet = Number(slider.dataset.columnsTablet || 3);
    const desktop = Number(slider.dataset.columnsDesktop || 4);
    const spaceMobile = Number(slider.dataset.spaceMobile || 8);
    const spaceTablet = Number(slider.dataset.spaceTablet || 16);
    const spaceDesktop = Number(slider.dataset.spaceDesktop || 16);
    const productsSize = Number(slider.dataset.productsSize || 0);
    const loop = slider.dataset.loop === 'true' && productsSize > desktop;

    const swiper = new Swiper(slider, {
      loop,
      speed: 800,
      autoHeight: true,
      allowTouchMove: true,
      slidesPerView: mobile,
      spaceBetween: spaceMobile,
      mousewheel: { forceToAxis: true },
      breakpoints: {
        750: { slidesPerView: tablet, spaceBetween: spaceTablet },
        1100: { slidesPerView: desktop, spaceBetween: spaceDesktop }
      },
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev')
      },
      pagination: {
        el: slider.querySelector('.popular-products__pagination'),
        clickable: true,
        type: 'custom',
        renderCustom(_swiper, current, total) {
          let output = '';
          for (let index = 1; index <= total; index += 1) output += `<span class="swiper-pagination-bullet${index === current ? ' swiper-pagination-bullet-active' : ''}" tabindex="0" role="button" aria-label="Go to slide ${index}"></span>`;
          return output;
        }
      }
    });

    const updateArrowPosition = () => {
      const image = section.querySelector('.media img');
      if (!image?.offsetHeight) return;
      if (!swiper.destroyed) {
        swiper.update();
        swiper.updateAutoHeight(0);
      }
      section.querySelectorAll('.swiper-button-prev, .swiper-button-next').forEach((arrow) => {
        arrow.style.top = `${image.offsetHeight / 2}px`;
        arrow.style.transform = 'translateY(-50%)';
      });
    };
    const firstImage = section.querySelector('.media img');
    if (firstImage?.complete) updateArrowPosition();
    else firstImage?.addEventListener('load', updateArrowPosition, { once: true });
    requestAnimationFrame(updateArrowPosition);

    section._flowcatProductSliderObserver?.disconnect();
    section._flowcatProductSliderObserver = new ResizeObserver(() => {
      if (swiper.destroyed) return;
      swiper.updateAutoHeight(0);
    });
    slider.querySelectorAll('.popular-products__item').forEach((item) => section._flowcatProductSliderObserver.observe(item));

    if (!section.dataset.flowcatHoverBound) {
      section.dataset.flowcatHoverBound = 'true';
      section.addEventListener('mouseover', (event) => {
        const active = event.target.closest('.popular-products__item');
        if (!active || !section.contains(active)) return;
        section.querySelectorAll('.popular-products__item').forEach((item) => item.classList.toggle('popular-products__item--inactive', item !== active));
      });
      section.addEventListener('mouseout', (event) => {
        if (event.relatedTarget?.closest('.popular-products__item') === event.target.closest('.popular-products__item')) return;
        section.querySelectorAll('.popular-products__item').forEach((item) => item.classList.remove('popular-products__item--inactive'));
      });
    }

    requestAnimationFrame(() => {
      if (swiper.destroyed) return;
      swiper.update();
      swiper.updateAutoHeight(0);
    });
    setTimeout(() => {
      if (swiper.destroyed) return;
      swiper.update();
      swiper.updateAutoHeight(0);
    }, 50);
  };

  const initAll = () => document.querySelectorAll('.section-product-slider').forEach(initSection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initSection(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    const swiper = event.target.querySelector('.swiper--products')?.swiper;
    if (!swiper || swiper.destroyed) return;
    swiper.update();
    swiper.updateAutoHeight(0);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target._flowcatProductSliderObserver?.disconnect();
    event.target.querySelector('.swiper--products')?.swiper?.destroy(true, true);
  });
})();
